import { Col, Form, Row, Tag } from 'antd';
import * as React from 'react';
import { useFormikContext } from 'formik';
import { DatePicker, Select, Switch, Input, Checkbox } from 'formik-antd';
import { useEffect, useState } from 'react';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { useIntl } from 'react-intl';
import IntlMessages from '../../../../../domain/utility/IntlMessages';
import FormItem from '../../../../../shared/components/form-item';
import LanguagesTab from '../../../../../shared/components/languages-tab';
import {
  UPLOAD_FILE_VALIDATE,
  UPLOAD_PICTURE_VALIDATE,
  formatDateTime,
} from '../../../../../shared/constants/AppConst';
import {
  BannerStatus,
  BannerTypes,
  UploadType,
} from '../../../../../shared/constants/AppEnums';
import { bannersService } from '../../../../../shared/services/banners';
import {
  AvailableBannersDto,
  BannersListDto,
} from '../../../../../shared/services/banners/dto/banners-list-dto';
import LanguageCode from '../../../../../shared/services/types/language-code';
import BannerLanguage from './banner-language';
import { useParams } from 'react-router-dom';
import UploadFileDate from 'src/shared/components/upload';
import { pictureService } from 'src/shared/services/admin-picture';
import moment from 'moment';
import MainUtils from 'src/shared/utils/main';
import { useLocaleContext } from 'src/domain/utility/AppContextProvider/LocaleContextProvide';
interface ICreateOrEditBannerInfoProps {
  bannerDetails?: BannersListDto;
  setBannerTypeSelected: any;
  mainCategories: AvailableBannersDto[];
  subCategories: AvailableBannersDto[];
  positioins: AvailableBannersDto[];
  bannerTypes: AvailableBannersDto[];
}

const CreateOrEditBannerInfo = (props: ICreateOrEditBannerInfoProps) => {
  const [fileListPicture, setFileListPicture] = useState<any[]>([]);
  const [fileListSmallPicture, setFileListSmallPicture] = useState<any[]>([]);
  const [convertLoading, setConvertLoading] = useState<boolean>(false);
  const [mainCategoryId, setMainCategoryId] = useState('');
  const [bannerType, setBannerType] = useState('');
  const [subCategoriesAll, setSubCategoriesAll] = useState<
    AvailableBannersDto[]
  >([]);
  const [isSubCategoriesAllLoading, setIsSubCategoriesAllLoading] =
    useState(false);
  const resolveImageUrl = (url: string | undefined, defaultImage?: string) => {
    if (!MainUtils.isEmptyValue(url)) {
      return url?.startsWith('http')
        ? url
        : `${process.env.REACT_APP_PUBLIC_BASE}${url}`;
    }
    return defaultImage;
  };


  let formData = new FormData();

  const {
    bannerDetails,
    setBannerTypeSelected,
    mainCategories,
    subCategories,
    positioins,
    bannerTypes,
  } = props;

  const { messages } = useIntl();
  const { id } = useParams();
  const { values, setFieldValue } = useFormikContext<any>();
  const { locale }: any = useLocaleContext();

  useEffect(() => {
    if (moment(values.startDate) > moment(values.endDate)) {
      setFieldValue('endDate', undefined);
    }
  }, [values]);

  const disabledDate = (current: any) => {
    if (current && current < moment(values.startDate).startOf('second')) {
      return true;
    }
    if (current && current.isSame(moment(values.startDate).startOf('second'))) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    if (bannerDetails) {
      const pictureUrl = resolveImageUrl(bannerDetails?.PictureUrl);
      const smallPictureUrl = resolveImageUrl(bannerDetails?.SmallSmallPictureUrl);

      setFileListPicture(
        pictureUrl
          ? [
            {
              uid: bannerDetails?.Attachment,
              status: 'done',
              url: pictureUrl,
            },
          ]
          : [],
      );

      setFileListSmallPicture(
        smallPictureUrl
          ? [
            {
              uid: bannerDetails?.SmallPicture,
              status: 'done',
              url: smallPictureUrl,
            },
          ]
          : [],
      );
    }
  }, [bannerDetails]);

  useEffect(() => {
    if (values?.type) {
      setBannerType(values?.type);
      setBannerTypeSelected(values?.type);
    }
  }, [values?.type]);

  useEffect(() => {
    setSubCategoriesAll(subCategories ?? []);
    if (subCategories?.length > 0 && !bannerDetails) {
      setFieldValue('subCategoryId', subCategories[0]?.Value);
    }
  }, [subCategories, bannerDetails]);

  useEffect(() => {
    if (mainCategoryId) {
      (async () => {
        try {
          setIsSubCategoriesAllLoading(true);
          let subCategories = await bannersService.getSubCategories(
            mainCategoryId,
          );
          setSubCategoriesAll(subCategories);
          if (subCategories && subCategories?.length > 0) {
            setFieldValue('subCategoryId', subCategories[0]?.Value);
          }
        } catch (error) {
          console.error(error);
        } finally {
          setIsSubCategoriesAllLoading(false);
        }
      })();
    }
  }, [mainCategoryId]);

  const langComponent = [
    {
      code: LanguageCode.English,
      langComponent: <BannerLanguage code={LanguageCode.English} index={0} />,
    },
    {
      code: LanguageCode.Español,
      langComponent: <BannerLanguage code={LanguageCode.Español} index={1} />,
    },
    {
      code: LanguageCode.Arabic,
      langComponent: <BannerLanguage code={LanguageCode.Arabic} index={2} />,
    },
  ];

  const renderBannerStatus = (value: any): React.ReactElement => {
    let tagColor: string = '';
    let bannerStatus: string = '';
    switch (value) {
      case BannerStatus.Pending:
        tagColor = 'blue';
        bannerStatus = messages['common.pending'].toString();
        break;
      case BannerStatus.Approved:
        tagColor = 'green';
        bannerStatus = messages['common.approved'].toString();
        break;
      case BannerStatus.Rejected:
        tagColor = 'red';
        bannerStatus = messages['common.rejected'].toString();
        break;
      default:
        break;
    }
    return (
      <Tag color={tagColor} className='ant-tag-disable-pointer'>
        {bannerStatus}
      </Tag>
    );
  };

  const handleChangeBannerType = (value: any) => {
    setBannerType(value);
  };

  const beforeUpload = (file: any, inputType: string) => {
    if (
      inputType === UploadType.PICTURE ||
      inputType === UploadType.SMALLPICTURE
    ) {
      if (!UPLOAD_PICTURE_VALIDATE.includes(file.type)) {
        return false;
      } else {
        return true;
      }
    } else if (inputType === UploadType.FILE) {
      if (!UPLOAD_FILE_VALIDATE.includes(file.type)) {
        return false;
      } else {
        return true;
      }
    }
  };

  const handleUploadFile = async (
    file: any,
    fileList: any,
    type: string,
    key?: string,
  ) => {
    try {
      formData.append('file', fileList[0]?.originFileObj);
      const pictureId = await pictureService.asyncUpload(formData);
      if (pictureId.success) {
        if (type === UploadType.PICTURE) {
          setConvertLoading(true);
          formData.delete('file');
          setFieldValue('attachment', pictureId.pictureId);
        } else if (type === UploadType.SMALLPICTURE) {
          setConvertLoading(true);
          formData.delete('file');
          setFieldValue('smallPicture', pictureId.pictureId);
        }
        file.onSuccess();
      } else {
        formData.delete('file');
      }
    } catch (error) {
      console.error(error);
    } finally {
      setConvertLoading(false);
    }
  };

  const uploadButtonSmallPicture = (
    <div>
      {convertLoading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>
        {messages['promotions.banners.smallPicture'].toString()}
      </div>
    </div>
  );
  const uploadButtonAttachment = (
    <div>
      {convertLoading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>
        {messages['promotions.banners.attachment'].toString()}
      </div>
    </div>
  );

  return (
    <Row gutter={[0, 20]}>
      <Col span={24}>
        <div className='languages-tab'>
          <LanguagesTab
            languagesList={langComponent}
            tabItem={{
              key: 'Standard',
              label: `${messages['promotions.banners.standard'].toString()}`,
              children: (
                <BannerLanguage
                  code={`${!MainUtils.isEmptyValue(locale.code)
                    ? locale.code
                    : LanguageCode.English
                    }`}
                />
              ),
            }}
          />
        </div>
      </Col>

      {id && (
        <Col span={24}>
          <FormItem
            name='status'
            label={messages['common.status'].toString()}
            fieldCommponent={renderBannerStatus(bannerDetails?.Status)}
          />
        </Col>
      )}

      <Col span={24}>
        <FormItem
          name='startDate'
          label={messages['common.startDate'].toString()}
          fieldCommponent={
            <DatePicker
              name='startDate'
              format={formatDateTime}
              showTime
              className='width-100'
            />
          }
        />
      </Col>

      <Col span={24}>
        <FormItem
          name='endDate'
          label={messages['common.endDate'].toString()}
          fieldCommponent={
            <DatePicker
              name='endDate'
              format={formatDateTime}
              showTime
              className='width-100'
              disabledDate={disabledDate}
            />
          }
        />
      </Col>

      <Col span={24}>
        <FormItem
          name='mainCategoryId'
          label={messages['promotions.banners.mainCategory'].toString()}
          fieldCommponent={
            <Select
              name='mainCategoryId'
              allowClear
              showSearch
              className='width-100'
              onSelect={(value) => {
                setMainCategoryId(value);
              }}
              filterOption={(input: any, option: any) =>
                MainUtils.filterOptions(input, option, true)
              }>
              {mainCategories?.map((item) => (
                <option
                  key={item.Id}
                  value={item.Id}
                  label={
                    item?.Locales?.find(
                      (record) => record.LanguageId === locale.code,
                    )?.LocaleValue ?? item.Name
                  }>
                  {item?.Locales?.find(
                    (record) => record.LanguageId === locale.code,
                  )?.LocaleValue ?? item.Name}
                </option>
              ))}
            </Select>
          }
        />
      </Col>

      <Col span={24}>
        <FormItem
          name='attachment'
          label={messages['promotions.banners.attachment'].toString()}
          fieldCommponent={
            <UploadFileDate
              accept={'image/*'}
              fileList={fileListPicture}
              setFileList={setFileListPicture}
              beforeUpload={(file: any) =>
                beforeUpload(file, UploadType.PICTURE)
              }
              customRequest={(file: any) =>
                handleUploadFile(file, fileListPicture, UploadType.PICTURE)
              }
              uploadButton={uploadButtonAttachment}
              listType='picture-card'
              deleteFile={() => setFieldValue('attachment', '')}
              showPic={true}
              maxCount={1}
            />
          }
        />
      </Col>

      <Col span={24}>
        <FormItem
          name='smallPicture'
          label={messages['promotions.banners.smallPicture'].toString()}
          fieldCommponent={
            <UploadFileDate
              accept={'image/*'}
              fileList={fileListSmallPicture}
              setFileList={setFileListSmallPicture}
              beforeUpload={(file: any) =>
                beforeUpload(file, UploadType.SMALLPICTURE)
              }
              customRequest={(file: any) =>
                handleUploadFile(
                  file,
                  fileListSmallPicture,
                  UploadType.SMALLPICTURE,
                )
              }
              uploadButton={uploadButtonSmallPicture}
              listType='picture-card'
              deleteFile={() => setFieldValue('smallPicture', '')}
              showPic={true}
              maxCount={1}
            />
          }
        />
      </Col>

      <Col span={24}>
        <FormItem
          name='position'
          label={messages['common.position'].toString()}
          fieldCommponent={
            <Select
              name='position'
              allowClear
              showSearch
              className='width-100'
              filterOption={(input: any, option: any) =>
                MainUtils.filterOptions(input, option, true)
              }>
              {positioins?.map((item) => (
                <option key={item.Value} value={item.Value} label={item?.Text}>
                  {item.Text}
                </option>
              ))}
            </Select>
          }
        />
      </Col>

      <Col span={24}>
        <FormItem
          name='isTimed'
          label={messages['common.isTimed'].toString()}
          fieldCommponent={
            <Switch
              name='isTimed'
              checkedChildren={<IntlMessages id='common.active' />}
              unCheckedChildren={<IntlMessages id='common.inactive' />}
            />
          }
        />
      </Col>

      <Col span={24}>
        <FormItem
          name='showName'
          label={messages['promotions.banners.showName'].toString()}
          fieldCommponent={
            <Switch
              name='showName'
              checkedChildren={<IntlMessages id='common.active' />}
              unCheckedChildren={<IntlMessages id='common.inactive' />}
            />
          }
        />
      </Col>

      <Col span={24}>
        <FormItem
          name='type'
          label={messages['promotions.banners.bannerType'].toString()}
          fieldCommponent={
            <Select
              name='type'
              allowClear
              showSearch
              className='width-100'
              onSelect={(value) => {
                handleChangeBannerType(value);
              }}>
              {bannerTypes?.map((item) => (
                <Select.Option key={item.Value} value={item.Value}>
                  {item.Text}
                </Select.Option>
              ))}
            </Select>
          }
        />
      </Col>

      <Col span={24}>
        <FormItem
          name='showProducts'
          label={messages['promotions.banners.showProducts'].toString()}
          fieldCommponent={<Checkbox name='showProducts' />}
        />
      </Col>

      {`${bannerType}` === BannerTypes.SubCategory && (
        <Col span={24}>
          <FormItem
            name='subCategoryId'
            label={messages['promotions.banners.subCategories'].toString()}
            fieldCommponent={
              <Select
                name='subCategoryId'
                allowClear
                showSearch
                loading={isSubCategoriesAllLoading}
                className='width-100'
                filterOption={(input: any, option: any) =>
                  MainUtils.filterOptions(input, option, true)
                }>
                {subCategoriesAll.map((item) => (
                  <option
                    key={item.Value}
                    value={item.Value}
                    label={item?.Text}>
                    {item.Text}
                  </option>
                ))}
              </Select>
            }
          />
        </Col>
      )}

      {`${bannerType}` === BannerTypes.Url && (
        <Col span={24}>
          <FormItem
            name='url'
            label={messages['promotions.banners.url'].toString()}
            fieldCommponent={<Input name='url' />}
          />
        </Col>
      )}

      {`${bannerType}` === BannerTypes.Products &&
        bannerDetails?.TypeValue !== BannerTypes.Products && (
          <Col span={24}>
            <div className='message-info'>
              {messages['promotions.banners.savebeforeedit'].toString()}
            </div>
          </Col>
        )}
    </Row>
  );
};

export default CreateOrEditBannerInfo;
